namespace Matrix.Data {
    export interface OwnershipProxyRow {
        InstanceCode?: string;
        OwnershipBasisCode?: string;
        SecurityId?: number;
        SecurityName?: string;
        AccountCode?: string;
        RowId?: number;
        Version?: number;
        CreatedBy?: string;
        CreatedWhen?: string;
        UpdatedBy?: string;
        UpdatedWhen?: string;
        InstanceCodes?: string[];
    }

    export namespace OwnershipProxyRow {
        export const idProperty = 'RowId';
        export const nameProperty = 'InstanceCode';
        export const localTextPrefix = 'Data.OwnershipProxy';
        export const deletePermission = 'DataAdmin:OwnershipProxy';
        export const insertPermission = 'DataAdmin:OwnershipProxy';
        export const readPermission = 'Read:OwnershipProxy';
        export const updatePermission = 'DataAdmin:OwnershipProxy';

        export declare const enum Fields {
            InstanceCode = "InstanceCode",
            OwnershipBasisCode = "OwnershipBasisCode",
            SecurityId = "SecurityId",
            SecurityName = "SecurityName",
            AccountCode = "AccountCode",
            RowId = "RowId",
            Version = "Version",
            CreatedBy = "CreatedBy",
            CreatedWhen = "CreatedWhen",
            UpdatedBy = "UpdatedBy",
            UpdatedWhen = "UpdatedWhen",
            InstanceCodes = "InstanceCodes"
        }
    }
}
